import { Inject, NgModule, DOCUMENT } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LayoutGapStyleBuilder } from "@ngbracket/ngx-layout";
import { CustomLayoutGapStyleBuilder } from "./flex-layout/custom-layout-gap-style-builder.service";
import { ToastrModule } from "ngx-toastr";
import { defaultGlobalConfig } from "./message/config/message.config";
import { provideNgxMask } from "ngx-mask";
import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe, TitleCasePipe } from "@angular/common";
import { SplashScreenService } from "../lib/splash-screen/splash-screen.service";
import { AppPageService } from "../lib/ui/app/app-page/app-page.service";
import { sentryProviders } from "./static/sentry";
import { initAppVersion } from "./static/init";
import { CookieService } from 'ngx-cookie-service';
import { EnumValueLabelPipe } from "../lib/ui/pipes/enum-label.pipe";
import { OfferTermLabelPipe } from "../lib/offer/pipes/offer-term-label-pipe";
import { matDateProviders } from "./static/mat-date";
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { GooglePlacesLoaderService } from '../lib/google-places/google-places-loader.service';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    ToastrModule.forRoot(defaultGlobalConfig)
  ],
  exports: [
    BrowserAnimationsModule
  ],
  providers: [
    provideNgxMask(),
    provideCharts(withDefaultRegisterables()),
    ...sentryProviders,
    ...matDateProviders,
    { provide: LayoutGapStyleBuilder, useClass: CustomLayoutGapStyleBuilder },
    SplashScreenService,
    DatePipe,
    CookieService,
    CurrencyPipe,
    PercentPipe,
    DecimalPipe,
    EnumValueLabelPipe,
    OfferTermLabelPipe,
    TitleCasePipe
  ],
})
export class CoreModule {
  constructor(
    @Inject(DOCUMENT) document: Document,
    splashScreenService: SplashScreenService,
    appPageService: AppPageService,
    googlePlacesLoader: GooglePlacesLoaderService
  ) {
    splashScreenService.init();
    appPageService.initUrlsHistory();
    initAppVersion(document);
    googlePlacesLoader.init();
  }
}
